module.exports = __webpack_public_path__ + "img/2.80097bed.jpg";